// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_inventory_management_ui_styles" + "." + "85ff1160" + ".chunk.css";
};